// 解决Vue-Router升级导致的Uncaught(in promise) navigation guard问题
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch((err) => err)
}
// ---------
import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import { init } from '@/api'
import { asyncRouterMap, constantRouterMap } from '@/config/router.config'
import { filterAsyncRouter } from '@/router/generator-routers'
import { message } from 'ant-design-vue'
// 全局注册
Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: constantRouterMap,
})

const whiteRouteList = ['/user/login']
const loginRoutePath = '/user/login'
const defaultRoutePath = '/'

router.beforeEach((to, from, next) => {
  to.meta.title && (document.title = to.meta.title)
  const ACCESS_TOKEN = localStorage.getItem('ACCESS_TOKEN')
  if (ACCESS_TOKEN) {
    // 登陆后 去登陆页面
    if (to.path === loginRoutePath) {
      next({ path: defaultRoutePath })
    } else {
      // 退出时 清空缓存和vuex 中的数据
      if (store.getters.ROLES.length === 0) {
        // 使用登陆权限
        init()
          .then((res) => {
            if (res.code === 0) {
              message.warning(res.msg)
            }
            // 用户权限过滤后的左侧目录
            store.commit('SET_MENUS', res['side_menu'])
            store.commit('SET_ROLES', res['auth_route'])
            // console.log(res['side_menu'])
            // console.log(res['auth_route'])
            // console.log(store.getters.ROLES)
            //检测权限 根据 auth_route  匹配 需要去除的路由 防止用户修改 url 来访问
            const asyncRouter = filterAsyncRouter(
              asyncRouterMap,
              res['auth_route']
            )
            // test !! console.log(res.auth_route)
            // const asyncRouter = filterAsyncRouter(asyncRouterMap, '*')
            router.addRoutes(asyncRouter)
            const redirect = decodeURIComponent(from.query.redirect || to.path)
            // 加载 roles 数据
            if (to.path === redirect) {
              next({ ...to, replace: true })
            } else {
              next({ path: redirect })
            }
          })
          .catch(() => {
            store.commit('SET_MENUS', [])
            store.commit('SET_ROLES', [])
            store.commit('SET_USER_INFO', {})
            localStorage.clear()
            next({ path: '/user/login', replace: true })
          })
      } else {
        next()
      }
    }
  } else {
    if (whiteRouteList.includes(to.path)) {
      next()
    } else {
      // 可以传递一个登陆后跳转的页面
      next({ path: loginRoutePath, query: { redirect: to.fullPath } })
    }
  }
})

export default router
